export const pt = {
  welcome: 'bem-vindo',
  logout: 'Logout',
  trading_accounts: 'contas de investimento',
  account_list: 'lista de contas',
  create_live_account: 'criar conta real',
  upgrade_to_live_account: 'atualizar para conta real',
  create_demo_account: 'criar conta demo',
  finance: 'finanças',
  deposit_funds: 'depositar capital',
  withdraw_funds: 'retirar capital',
  internal_transfer: 'transferência interna',
  external_transfer: 'transferência externa',
  transfer_back: 'transferência de volta',
  transfer_back_to_my_local_depositor: 'transferir de volta para o meu depositante local',
  transfer_to_external_account: 'transferir para uma conta externa',
  payment_history: 'histórico de pagamentos',
  my_cards: 'meus cartões',
  my_profile: 'meu perfil',
  personal_information: 'informações pessoais',
  change_password: 'alterar senha',
  upload_documents: 'carregar documentos',
  partner: 'parceiro',
  overview: 'visão geral',
  clients: 'Clientes',
  sub_ibs: 'Sub-IBs',
  payout: 'Pagamento',
  marketing_material: 'material de marketing',
  withdrawal_history: 'histórico de retirada',
  become_a_partner: 'torne-se um parceiro',
  please_fill_the_following_fields: 'por favor preencha os seguintes campos',
  what_geographic_region: 'Qual região geográfica você segmentará principalmente?',
  submit: 'Enviar',
  upload_documents_notice: 'Para aprovar totalmente sua conta e poder investir, <a>faça o upload de seus documentos</a> e complete seu perfil',
  change_password_ta_notice: 'Qualquer nova conta de investimento usará sua nova senha. Isso não afeta suas contas de investimento atuais.',
  changepass_error: 'A senha atual está errada, tente novamente.',
  changepass_success: 'Senha alterada com êxito',
  current_password: 'senha atual',
  new_password: 'nova senha',
  confirm_new_password: 'confirmar nova senha',
  pending_account: 'conta pendente',
  account_must_be_approved_message: 'Sua conta deve ser aprovada antes de criar uma nova conta de investimento real.',
  new_trading_account_message: 'Nova conta de investimento criada com sucesso',
  password_generated_for_ta: 'Uma senha foi gerada e enviada para o seu e-mail para a sua nova conta de investimento',
  new_trading_account_type_message: 'Nova conta de investimento {type} criada com sucesso',
  choose_your_desired_trading_platform_and_settings: 'Escolha a plataforma de investimento e as configurações desejadas',
  select_leverage: 'selecione alavancagem',
  create: 'criar',
  select_account_type: 'selecionar tipo de conta',
  select_currency: 'selecionar moeda',
  no_trading_account_found: 'Nenhuma conta de investimento encontrada.',
  bankwire_notice:
    'Obrigado por enviar seus dados bancários. Registaremos os seus dados no nosso banco. <br><br>Você receberá os detalhes da transferência por e-mail dentro de 24 horas, juntamente com sua referência de pagamento pessoal. Você pode usar esses detalhes para quaisquer depósitos futuros. <br><br><strong>IMPORTANTE:</strong> A referência de pagamento é personalizada para um cliente. Se você não usar a referência de pagamento que receber, não poderemos aceitar seu depósito. Nenhum terceiro pode usar a mesma referência de pagamento.',
  deposit: 'depósito',
  account_details: 'detalhes da conta',
  enter_fasapay_id: 'Introduza o seu ID de Conta Fasapay:',
  account_id: 'ID da conta',
  secure_id: 'ID Seguro',
  continue: 'continuar',
  bankwire_deposit_details_notice:
    'O nosso banco requer os seus dados bancários para processar o seu depósito. Quaisquer depósitos feitos via Transferência Bancária serão devolvidos à mesma conta a partir da qual você depositou.',
  bankwire_withdrawal_details_notice:
    'O nosso banco requer os seus dados bancários para processar o seu levantamento. Quaisquer levantamentos feitos através de Transferência Bancária serão devolvidos à mesma conta a partir da qual depositou.',
  bankwire_verify_account_notice:
    '<p>Você precisa verificar sua conta antes de usar a Transferência Bancária. Por favor, <a href="{FSROOT_URL}upload-documents">carregue seus documentos</a></p>',
  bankwire_amount_label: 'Valor ({minDeposit} min. depósito)',
  bank_name: 'nome do banco',
  full_name: 'nome completo',
  deposit_methods: 'métodos de depósito',
  deposit_select_ta_p: 'Por favor, selecione a conta de investimento para a qual você deseja depositar fundos:',
  coming_soon: 'em breve',
  amount: 'quantidade',
  proof_of_id: 'Comprovante de identidade',
  proof_of_id_instructions: 'Comprovante de identidade',
  documents_must_contain_all_of_the_following_details: 'Os documentos devem atender aos seguintes requisitos:',
  your_full_name: 'Seu nome completo',
  a_unique_id_number: 'Um número de identificação exclusivo',
  your_birthdate: 'Sua data de nascimento',
  your_place_of_birth: 'Seu local de nascimento',
  a_visible_photo: 'Uma foto visível',
  your_signature: 'A sua assinatura',
  your_nationality: 'A sua nacionalidade',
  proof_of_residence_instructions: 'Por favor, carregue sua conta de serviços públicos ou extrato bancário.',
  your_residential_address: 'Seu endereço residencial',
  date_of_issue: 'Data de emissão',
  other: 'outro',
  other_documents_instructions: 'Outros documentos que foram solicitados pelo nosso departamento de verificação.',
  deposit_failed: 'depósito falhou',
  deposit_successful: 'depósito bem sucedido',
  already_logged_in: 'já conectado',
  login: 'iniciar sessão',
  create_an_account: 'criar uma conta',
  partner_clients: 'Parceiro - Clientes',
  trades: 'trades',
  client_id: 'ID do cliente',
  trading_account: 'Conta de negociação',
  metatrader_web_client: 'metatrader cliente web',
  platform: 'plataforma',
  order: 'ordem',
  pair: 'par',
  volume: 'volume',
  close_date: 'data de fechamento',
  commission: 'comissão',
  status: 'estado',
  total_commission_generated: 'comissão total gerada',
  total_deposits: 'total de depósitos',
  total_withdrawals: 'total de levantamentos',
  date_joined: 'data de adesão',
  more: 'mais',
  banners: 'banners',
  partner_marketing_material: 'Parceiro - Material de marketing',
  partner_overview: 'Parceiro - Visão geral',
  partner_payout: 'Parceiro - Pagamento',
  partner_payout_request_message: 'O seu pedido foi registado.',
  select_your_default_payment_option: 'Selecione sua opção de pagamento padrão:',
  beneficiary_name_on_account: 'Beneficiário (Nome por conta)',
  bank_address: 'Endereço do Banco',
  sort_code: 'Código de classificação (para clientes do Reino Unido)',
  your_provider_email: 'Seu {provider} e-mail',
  select: 'selecionar',
  next: 'próximo',
  please_confirm_your_bank_details: 'Por favor, confirme os seus dados bancários:',
  bank: 'banco',
  sub_partners: 'Subparceiros',
  state: 'estado',
  date: 'data',
  internal_transfer_instructions:
    'Você pode transferir fundos entre suas contas de investimento. <br>Insira o valor da transferência desejada e selecione as contas de origem e destino.<br> As transferências internas são processadas imediatamente.',
  transfer_complete: 'transferência concluída',
  transfer_from: 'transferência de',
  internal_transfer_processed_successfully: 'A transferência interna foi processada com êxito.',
  external_transfer_processed_successfully: 'A transferência externa foi processada com êxito.',
  select_account: 'selecionar conta',
  to: 'para',
  warning_currency_conversion_will_take_place: 'aviso: a conversão de moeda ocorrerá',
  transfer: 'transferência',
  account: 'conta',
  currency: 'moeda',
  balance: 'Saldo ',
  equity: 'equidade',
  download: 'baixar',
  launch: 'lançar',
  email: 'e-mail',
  password: 'senha',
  forgot: 'esqueci',
  forgot_password: 'esqueceu a senha',
  risk_warning_footer:
    'Aviso de risco: A investimento de produtos alavancados, como Forex e CFDs, pode não ser adequada para todos os investidores, pois eles carregam um grau de risco para o seu capital. Certifique-se de que compreende completamente os riscos envolvidos, tendo em conta os seus objetivos de investimento e o nível de experiência, antes de investir e, se necessário, procure aconselhamento independente. Por favor, leia a <a href="{riskURL}">Divulgação de Risco</a> completa.',
  error_contact_support: 'Algo deu errado, entre em contato com o suporte.',
  type: 'tipo',
  funded: 'financiado',
  username: 'nome de usuário',
  company_name: 'nome da empresa',
  website: 'site',
  first_name: 'nome próprio',
  last_name: 'sobrenome',
  date_of_birth: 'data de nascimento',
  gender: 'gênero',
  phone: 'telefone',
  dial_code: 'código de discagem',
  country: 'país',
  address: 'endereço',
  year_moved_to_address: 'ano que mudou para o endereço',
  post_code: 'código postal',
  selected_currency: 'moeda selecionada',
  january: 'Janeiro',
  february: 'Fevereiro',
  march: 'Março',
  april: 'Abril',
  may: 'Maio',
  june: 'Junho',
  july: 'Julho',
  august: 'Agosto',
  september: 'Setembro',
  october: 'Outubro',
  november: 'Novembro',
  december: 'Dezembro',
  already_have_an_account: 'já existe uma conta',
  invalid_request_login_required: 'solicitação inválida, você precisa fazer login primeiro.',
  register_accounttype_account: 'registrar {accountType} conta',
  client_type: 'tipo de cliente',
  individual: 'individual',
  company: 'companhia',
  company_information: 'dados da empresa',
  company_website: 'site da empresa',
  complete_live_registration: 'registro real completo',
  title: 'título',
  confirm_password: 'confirmar senha',
  select_country: 'selecione o país',
  phone_number: 'número de telefone',
  choose_trading_platform: 'escolher plataforma de investimento',
  select_option: 'selecionar opção',
  day: 'dia',
  month: 'mês',
  year: 'ano',
  company_registration_information: 'informações de registro da empresa',
  date_of_registration: 'data de registo',
  select_nationality: 'selecionar nacionalidade',
  nationality: 'nacionalidade',
  select_gender: 'selecionar gênero',
  male: 'masculino',
  female: 'feminino',
  address_line: 'linha de endereço',
  city_town: 'cidade/vila',
  state_province: 'estado/província',
  select_year: 'selecionar ano',
  year_moved_to_current_address: 'ano que mudou para o endereço atual',
  company_shareholders_directors: 'acionistas e diretores da empresa',
  number_of_shareholders: 'número de acionistas',
  number_of_directors: 'número de diretores',
  shareholder: 'acionista',
  financial_information: 'informações financeiras',
  total_estimated_net_worth: 'património total estimado (€)?',
  less_than_amount: 'menor que {amount}',
  over_amount: 'acima {amount}',
  total_estimated_annual_income: 'rendimento anual total estimado (€)?',
  employment_information: 'informações sobre o emprego',
  employment_status: 'situação laboral',
  employed: 'empregado',
  self_employed: 'trabalhador(a) independente',
  retired: 'aposentado',
  student: 'estudante',
  unemployed: 'desempregado',
  source_of_income: 'fonte de renda',
  employment: 'emprego',
  inheritance: 'herança',
  investment: 'investimento',
  trading_experience: 'experiência de investimento',
  forex_cfds_and_other_instruments: 'FOREX, CFDS e outros instrumentos',
  yes: 'sim',
  no: 'não',
  lose_capital_risk:
    'Os produtos derivativos são adequados como parte dos meus objetivos de investimento e atitude em relação ao risco e sou capaz de avaliar o risco envolvido na investimento, incluindo a possibilidade de perder todo o meu capital',
  prev_pro_qualifications: 'Tenho qualificações profissionais anteriores e / ou experiência de trabalho no setor de serviços financeiros',
  account_type: 'tipo de conta',
  choose_currency: 'escolher moeda',
  tos_with_link: 'Li, compreendi e aceitei os termos e condições e a divulgação de avisos de risco <a target="_blank" href="{URL}">aqui</a>',
  registration_successful: 'registro bem-sucedido',
  reset_password_invalid_link: 'Seu link de redefinição é inválido, tente novamente ou entre em contato com o suporte.',
  reset_account_password: 'redefinir a senha da conta',
  choose_your_new_password: 'escolha sua nova senha',
  reset_password: 'redefinir senha',
  file_upload_failed_filename: 'o upload solicitado para o arquivo {filepath} falhou.',
  withdrawal_request_success_message: 'o seu pedido de levantamento foi bem sucedido',
  withdraw: 'retirada',
  please_fill_the_following: 'por favor, preencha o seguinte',
  cancel: 'cancelar',
  withdraw_select_ta_p: 'Por favor, selecione a conta de investimento da qual você deseja retirar:',
  free_margin_change_warning: 'Por favor, note que o levantamento deve ser feito com o mesmo método em que depositou na sua conta.',
  you_need_an_ib_account_to_visit_this_page: 'Você precisa de uma conta IB para visitar esta página',
  no_permission_to_to_visit_this_page: 'Você não tem permissão para visitar esta página',
  you_became_a_partner_successfully: 'Tornou-se um parceiro EUROTRADER com sucesso!',
  note_wallet_currency_conversion_partner:
    'Por favor, note que ao se tornar um Parceiro, a moeda da sua carteira será alterada para USD e que quaisquer fundos atuais serão convertidos para USD com a taxa de troca atual!',
  upgraded_to_a_live_account_successfully: 'Atualizado para uma conta real com sucesso!',
  passwords_dont_match: 'As senhas não coincidem',
  password_rules: 'Pelo menos 1 maiúscula, 1 minúscula e 1 número (6 a 16 caracteres máximos)',
  please_fill: 'por favor preencha',
  partner_verify_first_notice: 'Para se tornar um parceiro, você precisa verificar sua conta primeiro. Por favor, carregue seus documentos <a href="upload-documents">aqui</a>',
  only_currency_format_allowed: 'somente o formato de moeda permitido',
  please_enter_your_account_id: 'Introduza o ID da sua conta',
  min_deposit_with_bankwire_is_amount: 'O depósito mínimo com transferência bancária é {amount}',
  please_select_different_tas: 'Por favor, selecione diferentes contas de investimento',
  you_need_to_accept_our_tos: 'Você precisa aceitar nossos Termos e Condições.',
  phone_is_required: 'telefone é necessário',
  invalid_phone_number: 'número de telefone inválido',
  you_must_be_over_18: 'Você deve ter mais de 18 anos.',
  year_is_required: 'Ano é necessário',
  leave_page_question: 'Sair da página?',
  registration_exit_notice: 'Você ainda não terminou seu registro. Quer sair sem terminar?',
  internal_server_error_support: 'Erro interno do servidor. Entre em contato com o suporte',
  please_fill_all_fields: 'Por favor, preencha todos os campos',
  no_logs_found_for_this_client: 'Nenhum log encontrado para este cliente',
  no_accounts_send: 'Nenhuma conta enviada',
  internal_server_error_try_again: 'Erro interno do servidor. Tente novamente mais tarde',
  insufficient_balance: 'Equilíbrio insuficiente',
  currency_conversion_connection_error: 'Nenhuma resposta do servidor de conversão de moeda, tente novamente ou entre em contato com o suporte.',
  currency_conversion_error: 'Erro de conversão de moeda, tente novamente ou entre em contato com o suporte.',
  invalid_accounts: 'Contas inválidas',
  withdrawal_unsuccessful_equity_message: 'Retirada malsucedida, capital próprio insuficiente na conta de investimento {TAID}',
  withdrawal_failed_free_margin: 'A retirada falhou. Por favor, verifique novamente a sua margem livre.',
  pamm_copy_server_field_message: 'copie e cole o endereço IP no campo "Servidor" no seu servidor MT4',
  invalid_request: 'solicitação inválida',
  missing_shareholders_directors: 'Acionistas/administradores em falta',
  missing: 'Desaparecido',
  invalid_request_passwords_do_not_match: 'Solicitação inválida. As senhas não coincidem',
  email_exists_message: 'O e-mail existe, por favor, tente com outro endereço de e-mail.',
  your_payment_method_has_already_been_set: 'Sua forma de pagamento já foi definida. Entre em contato com o suporte',
  payment_method_is_required_message: 'O método de pagamento é obrigatório. Tente novamente ou entre em contato com o suporte',
  couldnt_find_your_account: 'Não foi possível encontrar sua conta',
  ta_limit_error_message: 'Sua conta atingiu o limite de contas de investimento({limit}) para {platform}.',
  error: 'erro',
  account_created_successfully: 'conta criada com sucesso',
  invalid_leverage: 'alavancagem inválida',
  insufficient_data_provided: 'dados insuficientes fornecidos',
  insufficient_data_provided_missing_field: 'Dados fornecidos insuficientes. Ausente {field}.',
  invalid_amount: 'valor inválido',
  account_taid_doesnt_exist: 'Conta {TAID} não existe',
  withdrawal_unsuccessful_equity_taid: 'Retirada mal sucedida, capital próprio insuficiente na conta de investimento {TAID}',
  withdrawal_unsuccessful_free_margin_taid: 'Retirada mal sucedida, margem livre insuficiente na conta de investimento {TAID}',
  internal_server_error: 'erro interno do servidor',
  deposit_failed_support: 'O depósito não foi bem-sucedido, entre em contato com o suporte.',
  upload_documents_instructions: 'Por favor, forneça-nos os seguintes documentos. <br>Os arquivos devem estar em formato PDF, JPG ou PNG e não devem exceder 5MB.',
  total_earned: 'total ganho',
  total_paid: 'total pago',
  total_clients: 'total de clientes',
  total_sub_ibs: 'total sub ibs',
  see_trading_accounts: 'ver contas de investimento',
  see_trades: 'veja os investimentos',
  welcome_title_live: 'Obrigado por abrir a sua conta na EUROTRADER!',
  welcome_title_demo: 'Obrigado por abrir a sua conta demo com EUROTRADER!',
  welcome_title_ib: 'Obrigado por abrir a sua conta de Parceiros com a EUROTRADER!',
  welcome_text_live:
    '<p>Para obter financiamento, aprovação e pronto para investir, você precisa concluir as seguintes etapas:</p><ul><li>Faça login no seu Portal do Cliente Eurotrader</li><li>Carregue seus documentos</li><li>Finacie sua conta</li><li>Comece a investir!</li></ul><p>Se você precisar de alguma ajuda, nossa simpática equipe de suporte ao cliente está disponível 24 horas por dia, 5 dias por semana. Para contatá-los, clique <a href="{contactURL}" target="_blank">aqui</a></p>',
  welcome_text_demo:
    '<p>Para obter financiamento, aprovado e pronto para investir, você precisa concluir as seguintes etapas:</p><ul><li>Baixe a plataforma MT4</li><li>Teste suas habilidades de investimento e nossas velocidades de execução</li><li>Faça login no seu Portal do Cliente e atualize para uma conta real</li><li>Carregue seus documentos e financie sua conta</li><li>investa no maior mercado financeiro do mundo!</li></ul><p>Se você precisar de alguma ajuda, nossa simpática equipe de suporte ao cliente está disponível 24 horas por dia, 5 dias por semana. Para contatá-los, clique <a href="{contactURL}" target="_blank">aqui</a></p>',
  welcome_text_ib:
    '<p>Para ter sua conta de parceiro aprovada e pronta para você receber seu URL de referência, você precisa concluir as seguintes etapas:</p><ul><li>Faça login no seu Portal do Cliente</li><li>Carregue seus documentos</li><li>Receba seu URL de rastreamento na seção "visão geral" e "ferramentas de marketing"</li><li>Indique seus clientes e receba comissão!</li></ul><p>Se você precisar de alguma ajuda, nossa simpática equipe de suporte ao cliente está disponível 24 horas por dia, 5 dias por semana. Para contatá-los, clique <a href="{contactURL}" target="_blank">aqui</a></p>',
  bankwire_passports_notice: 'IMPORTANTE: Passaportes como prova de identidade são necessários para fazer uma transferência bancária.',
  tracking_links: 'links de rastreamento',
  proof_of_residence: 'comprovante de residência',
  login_to_your_account: 'inicie a sessão<br>na sua conta',
  register: 'registro',
  open_demo_account: 'abrir conta demo',
  create_partner_account: 'criar conta de parceiro',
  page_title_partner: 'Torne-se um parceiro | Eurotrader',
  ib_payout_msg_monthly_payment: 'Os pagamentos são feitos bimestralmente através do método de sua escolha. Os pagamentos serão feitos nos dias 15 e 1º útil de cada mês.',
  payout_selection_complete: 'O método de pagamento foi selecionado.',
  home: 'home',
  about: 'sobre',
  account_types: 'tipos de conta',
  spreads: 'divulgar',
  funding: 'financiamento',
  education: 'educação',
  contact: 'contato',
  forex_broker: 'corretor FOREX',
  services_provided_by: 'Serviços financeiros prestados pela Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    'A Eurotrade SA (Pty) Ltd ("Eurotrader") é uma subsidiária da Eurotrade RGB Holdings Ltd (HE367109) e é um prestador de serviços financeiros autorizado, licenciado e regulado pela Financial Sector Conduct Authority (FSCA) na África do Sul, com o número de licença FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> com sede social em 74 Walmer street, Sydenham, Joanesburgo, 2192, África do Sul.<br><br><!-- » Eurotrader\' é uma marca registada da Eurotrade Investments RGB Ltd, uma empresa de investimento cipriota (CIF) sob o número de registo HE317893, licenciada e regulada pela Cyprus Securities and Exchange Commission (CySEC) sob a licença 279/15 com sede em 70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Chipre. O processamento do cartão será concluído pela Eurotrade Investments RGB Ltd.<br><br> -->A Eurotrader não presta serviços a residentes de determinadas jurisdições, incluindo os EUA, o Irão, o Canadá, a República Democrática da Coreia, a Bélgica, o Japão, e não se destina a distribuição ou utilização por qualquer pessoa em qualquer país ou jurisdição em que tal distribuição ou utilização seja contrária à lei ou regulamentação local. <br><br>A Eurotrade SA (PTY) Ltd não tem como alvo ativo os clientes da UE.',
  footer_risk_warning:
    'A investimento de produtos alavancados, como Forex e CFDs, pode não ser adequada para todos os investidores, pois eles carregam um grau de risco para o seu capital. Certifique-se de que compreende completamente os riscos envolvidos, tendo em conta os seus objetivos de investimento e o nível de experiência, antes de investir e, se necessário, procure aconselhamento independente. <a href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf" style="color: #e04ef8; text-decoration: underline" target="_blank">Por favor, leia a Divulgação de Risco completa.</a>',
  open_live_account: 'abrir conta real',
  not_registered_with_question: 'Não está registado na Eurotrader?',
  forgot_password_q: 'esqueceu sua senha?',
  pending_deposit_success: 'Operação bem-sucedida, seu depósito agora está pendente de aprovação',
  your_card_will_be_charged_cny: 'Seu cartão será cobrado <b>{amount}</b> CNY',
  currency_conversion_info: 'Informações de conversão de moeda',
  min_deposit_is_amount: 'O depósito mínimo é {amount}',
  min_transfer_is_amount: 'A transferência mínima é {amount}',
  local_depositor: 'Depositante local',
  converted_amount: 'valor convertido',
  from_currency: 'da moeda',
  to_currency: 'para a moeda',
  reference_id: 'id de referência',
  from_account: 'da conta',
  to_account: 'para a conta',
  from_date: 'a partir da data',
  to_date: 'até à data',
  target_account_id: 'ID da conta de destino',
  wallet: 'carteira',
  received: 'recebido',
  send: 'Enviar',
  sender_not_a_transfer_account: 'o remetente não é um depositante local',
  withdrawal_failed_support: 'A retirada não foi bem-sucedida, entre em contato com o suporte.',
  clear: 'claro',
  transfer_completed_successfully: 'transferência concluída com êxito',
  receive: 'receber',
  view_trades: 'ver investimentos',
  your_provider_account_number: 'Seu {provider} número de conta',
  your_bitcoin_address: 'Seu endereço bitcoin',
  your_crypto_address: 'Seu {crypto} endereço',
  destination_tag: 'Tag de destino',
  change_trading_account_password: 'alterar a senha da conta de investimento',
  your_card_will_be_charged_thb: 'Seu cartão será cobrado <b>{amount}</b> THB',
  dashboard: 'painel',
  sent: 'enviado',
  client_state_approved: 'aprovado',
  client_state_pending: 'pendente',
  client_state_incomplete: 'incompleto',
  open_trades: 'investimentos abertas',
  trade_history: 'histórico comercial',
  search_trades: 'pesquisar investimentos',
  trade_no: 'comércio não',
  symbol: 'símbolo',
  open_price: 'preço em aberto',
  close_price: 'preço de fechamento',
  datetime: 'data/hora',
  my_bonuses: 'meus bônus',
  bonus: 'bônus',
  conversion_progress: 'progresso da conversão',
  front_of_id: 'Frente do ID',
  back_of_id: 'Verso do ID',
  include_account_in_bonus_program: 'Eu gostaria de participar do Programa de investimento Financiado por 111%.',
  invest_under_master_account: 'investir em conta mestra',
  i_accept_the_terms_of_service: 'Eu aceito os Termos de Serviço',
  pamm_master_locks_withdrawals: '[este mestre pamm restringe retiradas durante investimentos abertas!]',
  open_p_l: 'abrir p&l',
  p_l: 'P&L',
  gains_prc: 'ganhos %',
  max_drawdown: 'rebaixamento máximo',
  bonus_tos_with_link: 'Li e compreendi os <a target="_blank" href="{URL}">termos e condições do Programa de investimento Financiado por</a> 111%.',
  i_am_over_18: 'Declaro que sou maior de 18 (dezoito) anos para abrir esta Conta.',
  all_time: 'o tempo todo',
  last_month: 'mês passado',
  last_week: 'semana passada',
  last_3_days: 'últimos 3 dias',
  monthly_avg: 'média mensal',
  profit: 'lucro',
  create_and_attach: 'criar e anexar',
  attach: 'anexar',
  create_and_attach_new_pamm_account: 'criar e anexar nova conta pamm',
  select_a_pamm_account_to_attach: 'selecione uma conta pamm para anexar',
  enter_private_code: 'insira o código privado',
  private_code: 'código privado',
  investor_link: 'Link do Investidor',
  i_accept_the_lpoa: 'Eu aceito o lpoa',
  invest: 'investir',
  view_graph: 'ver gráfico',
  name: 'nome',
  search: 'procurar',
  partners: 'parceiros',
  reject_withdrawls_during_open_trades: 'rejeitar retiradas durante investimentos abertas',
  private_master_account: 'conta mestra privada',
  minimum_deposit: 'depósito mínimo',
  performance_fee: 'taxa de desempenho',
  display_name: 'nome para exibição',
  new_master_account: 'nova conta mestra',
  pamm_statistics: 'estatísticas pamm',
  pamm: 'pamm',
  volume_traded: 'volume negociado',
  apply_date_range: 'aplicar intervalo de datas',
  pamm_master_locks_deposits: '[este mestre pamm restringe os depósitos durante as investimentos abertas!]',
  bitcoin: 'Bitcoin (em inglês)',
  register_live_account: 'registrar conta real',
  register_partner_account: 'registrar conta de parceiro',
  register_demo_account: 'registrar conta demo',
  risk_disclosure: 'divulgação de riscos',
  address_line_2: 'linha de endereço 2',
  skype_id: 'id skype',
  password_rules_extended:
    'A senha deve conter pelo menos: 1 letra maiúscula, 1 letra minúscula, 1 número e um caractere especial. O comprimento da senha deve estar entre 8 a 16 caracteres.',
  login_information: 'informações de login',
  director: 'diretor',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD.',
  pmethod_bitcoin: 'BITCOIN',
  pmethod_bankwire: 'Transferência bancária',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ideal',
  pmethod_instant_bank_transfer: 'Transferência Bancária Instantânea',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Carteira Jeton',
  pmethod_my_pay: 'O MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort •',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'CHÁVENA',
  pmethod_lydiax: 'Cripto',
  pmethod_safecharge: 'SafeCharge (em inglês)',
  pmethod_trustly: 'Trustly - Transferência Bancária',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'AstroPay',
  pmethod_payneteasy: 'Payneteasy',
  field_min_currency_value: 'O {field} campo deve ser {min} ou mais.',
  method_deposit: '{method} depósito',
  method_deposit_status: '{method} status do depósito',
  quick_menu: 'menu rápido',
  details: 'detalhes',
  date_from: 'data a partir de',
  date_to: 'data para',
  from: 'de',
  forgot_password_form_instruction: 'Envie o endereço de e-mail da sua conta abaixo. Você receberá um e-mail com um link para redefinir sua senha.',
  forgot_password_submit_success_message:
    'Um link de redefinição de senha foi enviado para o seu e-mail. Por favor, vá para o seu e-mail ({email}) e siga o link para alterar sua senha.',
  password_reset_successfully: 'Sua senha foi redefinida com êxito',
  password_too_week_or_mismatch: 'Senha muito fraca ou incompatibilidade de entradas de senhas.',
  withdrawals_credit_card_remaining_amount_message: 'A fim de retirar através de outros métodos, você deve primeiro retirar {amount} de volta para o seu cartão de crédito.',
  withdrawals_credit_card_refund_policy_message: 'Os provedores de cartão de crédito só permitem que você retire o valor total depositado de volta ao seu cartão.',
  withdrawals_amount_withdrawable_message:
    'Um total de {amount} pode ser retirado de volta para o seu cartão, qualquer coisa acima desse valor pode ser retirada por um dos nossos outros métodos.',
  country_blocked_for_this_method: 'Seu país está bloqueado para este método',
  copied_text_successfully: 'copiado {text} com êxito',
  choose_wallet_currency: 'escolha a moeda da carteira',
  pamm_master_account_created_successfully: 'Conta mestra PAMM criada com sucesso!',
  or_account_no_for_uk: 'ou Número da Conta (para Clientes do Reino Unido)',
  issue_date: 'Data de emissão',
  expiry_date: 'Data de vencimento',
  full_copy_of_the_document: 'Cópia completa do documento mostrando todos os 4 cantos',
  recent_date: 'Data recente (não superior a 3 meses)',
  your_physical_address: 'Seu endereço físico, correspondente ao endereço que você usou ao se registrar para a conta',
  must_be_a_utility_bill: 'Deve ser uma conta de serviços públicos (eletricidade, água, telefone, gás / energia, imposto municipal / contas de saneamento) ou um extrato bancário',
  for_further_info_attach: '**Para mais documentação, anexe-os em um e-mail e envie para backoffice@eurotrader.com',
  banners_ad_blocker_notice: 'Se você tiver problemas para visualizar os banners abaixo, desative o bloqueador de anúncios',
  content_ad_blocker_notice: 'Se você tiver problemas para visualizar o cliente da Web, desative o bloqueador de anúncios',
  transfer_out: 'transferência para fora',
  transfer_in: 'transferência em',
  done: 'terminado',
  not_required: 'não é necessário',
  wallet_balance: 'saldo da carteira:',
  must_agree_terms: 'Você deve concordar com nossos Termos e Condições para criar uma conta',
  select_payment_method: 'selecionar método de pagamento',
  islamic_account: 'Conta islâmica',
  islamic_documents_instructions: 'Prova de fé/religião da mesquita',
  card_number: 'número do cartão',
  expiry: 'Caducidade',
  redeem: 'resgatar',
  must_be_multiple_of_10: 'O valor deve ser um múltiplo de 10',
  select_starting_balance: 'Selecione o saldo inicial',
  business_name: 'nome da empresa',
  business_bank_wire_instructions: 'instruções de transferência bancária comercial',
  error_request_failed: 'Erro: Falha na solicitação',
  error_no_user_with_this_email: 'Erro: Uma conta com este endereço de e-mail não foi encontrada',
  error_too_many_password_reset_requests: 'Erro: Muitas redefinições de senha solicitadas',
  error_expired_or_invalid_request: 'Erro: Solicitação inválida ou expirada',
  error_insufficient_wallet_balance: 'Erro: Saldo insuficiente na carteira',
  error_insufficient_balance_or_equity: 'Erro: Saldo ou patrimônio líquido insuficiente',
  error_pamm_master_deposit: 'Não é possível depositar em uma conta mestra PAMM',
  error_pamm_master_withdrawal: 'Não é possível retirar de uma conta mestra PAMM',
  error_pamm_master_locked_deposits: 'Rejeitado: O pamm master da conta na qual o dinheiro é depositado rejeita os depósitos durante as investimentos abertas.',
  error_pamm_master_locked_withdrawals: 'Rejeitado: O pamm master da conta da qual o dinheiro é retirado rejeita retiradas durante investimentos abertas.',
  error_pamm_master_minimum_deposit: 'Rejeitado: O requisito de depósito mínimo do pamm master não foi cumprido.',
  error_live_account_already: 'Sua conta já é uma conta real',
  error_min_balance_required_is: 'O saldo mínimo necessário para a {TAAccountType} conta({TAID}) é {min}{currency}.',
  error_transfer_same_wallet: 'Não é possível transferir de carteira para carteira.',
  error_transfer_same_trading_account: 'Não é possível transferir de e para a mesma conta de investimento.',
  error_no_deposit_bonus_account_deposit_restricted: 'Depósitos no tipo de conta "Sem Bônus de Depósito" não são permitidos.',
  error_no_deposit_bonus_base_amount_withdrawal: 'Não é possível retirar o valor base do "Bônus Sem Depósito".',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: 'Não é possível retirar o "Bônus Sem Depósito" se o requisito de lucro não tiver sido atendido.',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: 'Não pode retirar mais do que o lucro máximo retirável.',
  upgrade_required_for_live_ta: 'A conta de cliente real e aprovado é necessária antes que uma conta de investimento real possa ser aberta!',
  error_wallet_currency_not_allowed_for_psp: 'A moeda da carteira não é permitida para este método de pagamento.',
  error_invalid_or_expired_otp: 'Erro: Desde que a OTP seja inválida ou expirada.',
  error_max_confirmo_withdrawal_exceeded: 'Erro: O pedido máximo de retirada confirmo é 20000 EUR/USD',
  error_max_anual_vload_withdrawal_exceeded: 'Erro: Máximo anual vload solicitações de retirada valor total excedido',
  is_islamic_acc_message: 'Para criar uma conta islâmica, envie uma solicitação para backoffice@eurotrader.com para ajudá-lo ainda mais.',
  error_invalid_voucher: 'Erro: VLoad voucher inválido ou já resgatado',
  error_blocked_voucher: 'Erro: VLoad Voucher está bloqueado devido a suspeita de fraude',
  error_voucher_data_mismatch: 'Erro: O VLoad Voucher foi recusado devido à incompatibilidade de dados da conta.',
  error_vload_voucher_below_minimum: 'Erro: Vload voucher abaixo do valor mínimo do depósito.',
  my_bank_has_a_swift_code: 'Meu banco tem um código rápido',
  my_bank_does_not_have_a_swift_code: 'Meu banco não tem um código rápido',
  bank_not_in_swift_network_instructions:
    'Se o seu banco não for um membro da rede SWIFT, forneça-nos os seguintes detalhes do banco correspondente do seu banco para receber transferências internacionais:',
  correspondent_bank_name: 'Nome do Banco Correspondente',
  correspondent_bank_city: 'Cidade do Banco Correspondente',
  correspondent_bank_swift: 'Swift do Banco Correspondente',
  proof_of_cc: 'Comprovante de Cartão de Crédito/Débito',
  front_of_cc: 'Frente do cartão',
  back_of_cc: 'Verso do cartão',
  proof_of_cc_instructions: 'Por favor, carregue o seu cartão de crédito ou débito.',
  add_document: 'Adicionar um documento (Opcional)',
  cc_requirements_1: 'Cópia completa do documento mostrando todos os 4 cantos.',
  cc_requirements_2:
    'Nome do cartão: o cartão que você usará deve ser emitido apenas em seu nome. Quaisquer depósitos feitos usando um cartão pertencente a terceiros, serão imediatamente reembolsados.',
  cc_requirements_3: 'Prazo de validade: não inferior a 3 meses.',
  cc_requirements_4:
    'Número do cartão: Os oito números do meio do cartão devem ser cobertos com um pedaço de papel. Apenas os primeiros quatro e os últimos quatro dígitos devem estar visíveis.',
  cc_back_requirements_5: 'Código CVV: Por favor, use um pedaço de papel para cobrir o código CVV.',
  cc_back_requirements_6: 'O cartão deve ser assinado.',
  click_to_add_another_document: 'Clique acima para adicionar outro slot de upload de documento',
  add_up_to_4_extra_documents: 'Você pode adicionar até 4 documentos adicionais',
  add_up_to_10_extra_documents: 'Você pode adicionar até 10 documentos adicionais',
  complete_profile: 'Perfil Completo',
  document_received: 'Seu documento foi recebido e será revisado por nossa equipe.',
  please_check_the_box: 'Por favor, marque a caixa abaixo.',
  must_be_over_18: 'Você deve ter mais de 18 anos de idade para se registrar.',
  shareholders_must_be_over_18: 'Os acionistas devem ter mais de 18 anos de idade para se registrar.',
  directors_must_be_over_18: 'Os diretores devem ter mais de 18 anos de idade para se inscrever.',
  document_req_color: 'O documento deve estar colorido',
  internal_error: 'Ocorreu um erro interno.',
  please_enter_your_email: 'Introduza o seu endereço de e-mail.',
  do_you_want_to_transform_your_trading: 'Você quer transformar seu investimento?',
  reset_your_password_to_transfer_your_account: 'Redefina sua senha para transferir sua conta.',
  reset_your_old_password: 'Redefinir sua senha antiga',
  reset_password_desc: 'Devido a uma transferência do sistema, você é obrigado a atualizar sua senha. Use o formulário abaixo para receber um link de redefinição de senha.',
  eurotrader_login: '| de Login Eurotrader Entre no centro de investimento para aumentar o nível do seu investimento',
  your_email_is_verified: 'Seu e-mail já está verificado.',
  click_here_to_login: 'Clique aqui para fazer o login',
  success_email_verified: 'Sucesso, seu e-mail já está verificado!',
  your_link_expired: 'Seu link expirou',
  click_here_to_request_verification_email: 'Clique aqui para solicitar um novo e-mail de verificação.',
  a_new_verification_link_send: 'Um novo link de verificação foi enviado para o seu endereço de e-mail.',
  invalid_request_please_check_your_link: 'Solicitação inválida. Verifique se o link está correto e tente novamente.',
  invalid_verification_code: 'Código de verificação inválido',
  please_enter_amount: 'Por favor, insira o valor que você deseja depositar',
  bankwire_company_desc:
    '<p>Se você é titular de uma conta bancária comercial e deseja usar a opção de transferência bancária registrando sua conta comercial conosco, envie-nos a seguinte documentação por e-mail para backoffice@eurotrader.com</p><ul><li>Certificado de Incorporação/Empresa</li><li>Certificado de Diretores e Secretário, se aplicável</li><li>Certificado de Acionistas Registrados/Proprietário Único.</li><li>Memorando e Estatutos, também conhecido como Artigos</li><li>Comprovante de Identificação e Endereço para todos os Acionistas registrados,  Beneficiário(s) Efetivo(s) e Diretor(es).</li><li>Comprovante de endereço relativo à empresa.</li></ul><p>Quaisquer outros documentos governamentais/oficiais que verifiquem as informações acima solicitadas podem ser considerados suficientes, caso os documentos acima não possam ser fornecidos em tal formato.</p>',
  bankwire_noncompany_desc:
    '<p>Isso irá desconectá-lo de sua conta pessoal e redirecioná-lo para a nossa página de registro para uma conta da Empresa.</p> <p>Gostaria de prosseguir?</p>',
  please_enter_card_detail_and_amount: 'POR FAVOR, INSIRA OS DETALHES DO CARTÃO E O VALOR QUE VOCÊ DESEJA DEPOSITAR',
  important: 'IMPORTANTE',
  please_note_that_the_maximum_deposit_amount: 'Por favor, note que o valor máximo do depósito por dia é de $1000 por cartão.',
  city: 'Cidade',
  zip: 'Nada',
  please_note_that_after_three_unsuccessful_attempts:
    '* Por favor, note que após três (3) tentativas malsucedidas, a opção de pagamento VISA/MASTERCARD ficará indisponível por 24 horas.',
  epay_pro_desc:
    '<p>Caro Trader<br><br>Infelizmente, devido a certas questões técnicas e restrições, os Depósitos com Cartão de Crédito serão temporariamente desativados através do nosso provedor EPayPro.<br><br>Visa &amp; Mastercard serão desativados à meia-noite 23:00 GMT 04/04/2018. Após a desativação do provador de pagamento, os depósitos serão temporariamente desativados. Embora nossos provedores de pagamento não tenham nos fornecido um prazo exato para o tempo de inatividade, estamos trabalhando na implementação de alternativas o mais rápido possível. <br><br>Estamos trabalhando com nossos provedores para resolver os problemas atuais para que, no futuro, as contas possam retomar o processamento de depósitos sem demora. <br><br>Sinta-se à vontade para entrar em contato com nossa equipe de suporte caso tenha mais alguma dúvida.</p>',
  provider_redirect: 'Você será redirecionado para {provider}.',
  lydiax_note: 'O depósito mínimo é de 30 EUR/USD',
  lydiax_note1:
    'Se você depositar menos de 30 EUR/USD em {crypto}, você precisará enviar um e-mail para backoffice@eurotrader.com e solicitar um reembolso, fornecendo o endereço {crypto} para o qual deseja ser reembolsado.',
  lydiax_note2:
    'Por favor, insira o {crypto} valor que você deseja depositar para ver uma estimativa do que você receberá. Tenha em mente que os preços a seguir são válidos apenas para quando foram solicitados e podem mudar a qualquer momento.',
  lydiax_note3: 'Criaremos um endereço de depósito para você usar.',
  lydiax_note4: 'Por favor, use o seguinte endereço para depositar {crypto}.',
  lydiax_note5: 'Doravante, este endereço exclusivo será usado para seus depósitos em {crypto}.',
  lydiax_required_address: 'Se a sua carteira exigir endereço e etiqueta separadamente, use:',
  tag: 'Etiqueta',
  lydiax_enter_deposit: 'POR FAVOR, INSIRA A CRIPTOMOEDA QUE VOCÊ DESEJA DEPOSITAR',
  create_address: 'Criar endereço',
  please_note: 'Atenção:',
  price_estimate: 'Estimativa de preço:',
  check_price: 'Verificar preço',
  vload_please_enter_voucher: 'INTRODUZA O NÚMERO PIN DO SEU VOUCHER VLOAD',
  vload_minimum: '<p>(O valor mínimo aceitável do voucher é <b>50</b> EUR ou USD!)</p>',
  vload_vouchers: 'Preciso comprar Vouchers VLoad',
  vload_note:
    'Faça um pagamento sem complicações por Visa / MasterCard, bem como Transferência Bancária.<br>Saiba mais sobre VLoad ou compre um voucher [EUR / USD] em vload.expert.',
  vload_note1: 'Para poder depositar com o VLoad, sua conta deve primeiro ser aprovada!',
  reason: 'Razão:',
  attempts: 'Tente {attempts} de {maxAttempts},',
  two_more_remaining: 'mais dois (2) restantes',
  one_more_remaining: 'Apenas UMA (1) tentativa restante',
  please_contact_bank: '<br>Entre em contato com o banco emissor do cartão.<br> Seu cartão pode ser bloqueado para transações no exterior',
  edata_success_note:
    'Por favor, note que poderá haver uma taxa adicional no seu depósito, cobrada pelo seu banco emissor devido à transação internacional. Essa taxa será pequena, mas variará de banco para banco. <br><br>Esta transação com cartão de crédito aparecerá no seu extrato como "Tech Savvy Billing", "Business Billing" ou "Business media Billing".',
  you_can_try: 'você pode tentar novamente',
  here: 'aqui',
  safe_charged_success_message: 'O seu depósito será processado pelo nosso backoffice no prazo de 2 dias úteis.',
  thank_you: 'Obrigado!',
  your_deposit_successful: 'Seu depósito foi bem sucedido',
  card_redirect: 'Você será redirecionado para inserir seu cartão de crédito e detalhes pessoais.',
  bank_wire_withdrawal_note:
    'Em caso de rejeição de uma Transferência Bancária em nome do banco receptor devido a dados bancários errados fornecidos pelo cliente, as várias despesas de administração de transferência bancária cobradas pelos bancos envolvidos serão subtraídas do valor de retirada solicitado antes de creditar a carteira do cliente.',
  please_enter_amount_withdraw: 'Por favor, insira o valor que você deseja retirar',
  bitcoin_note: 'Por favor, insira seu endereço bitcoin e o valor que você deseja retirar',
  otp: 'Senha de uso único (OTP)',
  otp_send_email: 'Enviar OTP para e-mail',
  otp_additional_text: 'A OTP acima é para o atual pedido de retirada de Bitcoin que você está fazendo',
  otp_new_password: 'Uma nova senha de uso único (OTP) foi enviada para o seu e-mail',
  otp_error: 'Erro - Falha ao enviar OTP',
  lydiax_withdrawal_note:
    'Por favor, insira o valor {currency} que você deseja retirar para ver uma estimativa de {crypto} que você receberá. Tenha em mente que os preços a seguir são válidos apenas para quando foram solicitados e podem mudar a qualquer momento.',
  enter_currency_amount: 'Insira o valor de {currency} para verificar a estimativa',
  lydiax_withdrawal_additional_note: 'A OTP acima é para a solicitação de retirada atual da Crypto que você está fazendo',
  estimated: 'Estimado:',
  please_enter_your_crypto_address: 'Por favor, insira seu endereço {crypto} e o valor que você deseja retirar',
  select_cryptocurrency: 'Selecione a criptomoeda',
  request_amount: 'Valor Solicitado',
  amount_changes: 'Valor cobrado (inclui taxa)',
  operation_failed: 'A operação falhou! Sua solicitação foi inválida.',
  operation_failed_error: 'A operação falhou! Ocorreu um erro ao processar este pedido.',
  are_you_sure_create_master: 'Tem certeza de que deseja criar uma nova conta e anexá-la a este mestre?',
  are_you_sure_attach_selected_account_to_master: 'Tem certeza de que deseja anexar a conta selecionada a este mestre?',
  change_password_desc:
    '<strong>*</strong> Esta alteração de palavra-passe não afetará as palavras-passe da sua conta de investimento. Por favor, visite a <strong>lista de</strong> contas para alterar as senhas da sua conta de investimento, usando a opção de <strong>alteração de senha</strong> sob o ícone de engrenagem.',
  client_assessment: 'AVALIAÇÃO DO CLIENTE',
  select_answer: 'Selecione uma resposta...',
  declarations: 'DECLARAÇÕES',
  complele_profile_desc:
    'Você está atualmente, ou já esteve, envolvido em alguma atividade criminosa ou há alguma acusação criminal pendente contra você pendente perante um tribunal?',
  complete_profile_desc1:
    'Você ou um parente ou associado próximo seu é uma pessoa politicamente exposta? As Pessoas Politicamente Expostas são as pessoas singulares a quem foram ou foram confiadas funções públicas proeminentes nos últimos 12 meses, ou seja, Chefes de Estado ou de Governo, altos políticos, altos funcionários do governo, funcionários judiciais ou militares, altos executivos de empresas estatais, importantes funcionários de partidos políticos.',
  are_you_us_citizen: 'Você é um cidadão dos EUA ou residente dos EUA para fins fiscais?',
  please_check_forms_errors: 'Por favor, verifique os formulários para erros!',
  profile_succesfully_completed: 'Perfil concluído com êxito',
  please_select_country: 'Por favor, selecione o seu país',
  set_country: 'Definir país',
  empty_country_code: 'Código de país vazio, atualize a página e tente novamente.',
  invalid_country_code: 'Código de país inválido, atualize a página e tente novamente.',
  individual_company: 'VOCÊ É UM INDIVÍDUO OU UMA EMPRESA?',
  prev: 'PREV',
  previous: 'ANTERIOR',
  complete: 'COMPLETAR',
  please_select_an_option: 'Por favor, selecione uma opção para cada campo!',
  swap: 'trocar',
  buy: 'comprar',
  sell: 'vender',
  sums: 'somas',
  net_total: 'NET TOTAL',
  deposit_page_desc:
    '<p class="has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold">Inscreva-se agora e</p><p class="is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">Receba um <span class="has-text-white has-text-weight-bold"> GRÁTIS </span> <br> 10 EUR/ USD<br> eVoucher</p>',
  deposit_page_desc1: 'O eVoucher de Bónus de 10 EUR/USD será ativado assim que o utilizador',
  create_new_account: 'Criar uma nova conta',
  successfully_purchase_vload: 'comprar e resgatar com sucesso um eVoucher VLoad de qualquer valor',
  upgrade_to_tier_2: 'Atualize para o nível 2',
  register_now: 'REGISTE-SE AGORA',
  back: 'VOLTAR',
  my_card_desc: 'Aqui você pode ver todos os cartões que você usou para pagamentos e seu status atual em nosso sistema.',
  you_have_no_card: 'Você ainda não fez depósitos com cartão.',
  card_no: 'Nº do cartão',
  last_used: 'Última utilização',
  risk_warning: 'AVISO DE RISCO',
  upload_documents_note: 'Se você deseja fazer um depósito com cartão, por favor, forneça adicionalmente os seguintes documentos a serem verificados e aprovados.',
  please_select_your_country: 'Por favor, selecione o seu país primeiro',
  add_another_document: 'Adicionar outro documento',
  drop_files_upload: 'Solte arquivos aqui para fazer upload',
  date_until: 'Data Até',
  copy: 'Copiar',
  cvv: 'CVV',
  please_enter_crypto_amount: 'Insira o valor {crypto}',
  vload_pin: 'Pino VLoad',
  deposit_info:
    "O provedor de pagamento está atualmente enfrentando problemas técnicos e os depósitos diretos Visa/Mastercard estão atualmente indisponíveis. Alternativamente, se você gostaria de depositar usando Visa / Mastercard, você pode usar a opção 'Vload'",
  id: 'ID',
  pamm_modal_error: 'Entrada inválida para Nome para Exibição. Por favor, não deixe vazio ou digite mais de 32 caracteres',
  pamm_modal_error1: 'Valor inválido inserido para Depósito Mínimo. Insira um número inteiro positivo abaixo de 1.000.000.',
  error_missing_required_field: 'Erro, campo obrigatório ausente',
  page_not_found: 'PÁGINA NÃO ENCONTRADA',
  new_version_note: 'NOVA VERSÃO DETECTADA, POR FAVOR CLIQUE AQUI PARA ATUALIZAR',
  new_version_note1: 'Algumas funções podem estar indisponíveis até que você atualize a página',
  records: 'Arquivo',
  gateway: 'porta',
  account_no: 'Nº da Conta',
  routing_no: 'Nº de roteamento',
  train_up: 'TREINE.',
  trade_up: 'TROQUE.',
  train_text_1: 'Pronto para investir no seu eu futuro?',
  train_text_2: 'Comece com uma conta demo sem risco e acesso aos recursos de aprendizagem da Eurotrader Academy.',
  train_list_item_1: 'Pratique a investimento em um ambiente simulado.',
  train_list_item_2: 'Obtenha acesso aos melhores recursos de aprendizagem da classe.',
  train_list_item_3: 'Torne-se parte da comunidade Eurotrader.',
  train_list_item_4: 'Lembre-se: nada a perder, tudo a ganhar.',
  form_title_1: 'COMECE A PRATICAR COM',
  form_title_2: 'TEU',
  form_title_3: 'Conta Demo',
  form_subtitle: 'E tenha acesso a recursos de aprendizagem',
  region: 'Região',
  wallet_currency: 'Moeda da carteira',
  select_currency_label: 'Moeda da sua conta demo',
  join: 'juntar',
  demo_account: 'Conta Demo',
  page_title_demo: 'Abra a conta demo | Eurotrader',
  title_404: 'EI DINHEIRO, ESTOU EM CASA!',
  text_line_1_404: 'Que? Ninguém aqui para ajudá-lo a investir em seu eu futuro?',
  text_line_2_404: 'Vamos voltar para casa e mostrar ao seu dinheiro do que você é feito.',
  button_404: 'VOLTAR',
  remember_me: 'Lembrar-me',
  risk_sentence: 'Para ver como utilizamos os seus dados, consulte os nossos',
  video_courses: 'Cursos em Vídeo',
  ebooks: 'E-Livros',
  knowledge_and_experience: 'CONHECIMENTO E EXPERIÊNCIA',
  economic_profile: 'PERFIL ECONÔMICO',
  product_governance: 'GOVERNANÇA DE PRODUTOS',
  select_an_answer: 'Selecione uma resposta',
  declarations_q1: 'Você está atualmente, ou já esteve, envolvido em alguma atividade criminosa ou há alguma acusação criminal pendente contra você pendente perante um tribunal?',
  declarations_q2:
    'Você ou um parente ou associado próximo seu é uma pessoa politicamente exposta? As Pessoas Politicamente Expostas são as pessoas singulares a quem foram ou foram confiadas funções públicas proeminentes nos últimos 12 meses, ou seja, Chefes de Estado ou de Governo, altos políticos, altos funcionários do governo, funcionários judiciais ou militares, altos executivos de empresas estatais, importantes funcionários de partidos políticos.',
  declarations_q3: 'Você é um cidadão dos EUA ou residente dos EUA para fins fiscais?',
  ca_q1: '1. Você tem experiência de investimento?',
  ca_q2: '2. Há quanto tempo você investe/negocia nos mercados financeiros?',
  ca_q3: '3. Quantas transações você executou nos últimos dois anos?<br> a. Ações e Renda Fixa (Ações e Títulos)',
  ca_q4: '&nbsp;&nbsp; b. Forex',
  ca_q5: '&nbsp;&nbsp; c. CFDs (Contratos por Diferenças)',
  ca_q6: '&nbsp;&nbsp; d. Outros Produtos Derivados (Warrants, Opções, Direitos)',
  ca_q7: '4. Quais foram os valores médios (mensalmente) que você investiu nas seguintes categorias?<br> a. Ações e Renda Fixa (Ações e Títulos)',
  ca_q8: '&nbsp;&nbsp; b. Forex',
  ca_q9: '&nbsp;&nbsp; c. CFDs (Contratos por Diferenças)',
  ca_q10: '&nbsp;&nbsp; d. Outros Produtos Derivados (Warrants, Opções, Direitos)',
  ca_q11: '5. Que tipo de serviços de investimento já utilizou? (contém várias respostas)',
  ca_q12: '6. Alguma das opções abaixo se aplica a você? (contém várias respostas)',
  ca_q13:
    '7. A ação da Apple está sendo negociada a um preço de venda de US $ 204 e um preço de compra de US $ 206. Você compra 100 ações da Apple pelo preço acima mencionado. Qual seria o lucro/perda incorrido em sua conta se o preço da ação da Apple se movesse a um preço de venda de US $ 190 e um preço de compra de US $ 192 e você fechasse sua posição?',
  ca_q14:
    '8. O Apple Share está sendo negociado a um preço de venda de US $ 204 e a um preço de compra de US $ 206. Você abre um investimento (compra) de CFD para 100 contratos (cada contrato sublinha 1 ação da Apple). A alavancagem utilizada é de 1:5. Qual seria o lucro/perda incorrido em sua conta se o preço da ação da Apple se movesse a um preço de venda de US $ 190 e um preço de compra de US $ 192 e você fechasse sua posição?',
  ca_q15: '9. Usando uma ordem de stop loss:',
  ca_q16: '10. O saldo da sua conta é baixo. Em qual dessas ocasiões você pode ser obrigado a adicionar fundos à sua conta?',
  ca_q17:
    '11. O índice S&P 500 tem um preço de compra de US$ 2700. Você decide abrir um investimento (comprar) CFD de 2 contratos. A alavancagem utilizada é de 1:20. Você define um stop loss ao preço de US $ 2600 e um lucro ao preço de US $ 3000. Supondo que o saldo em sua conta seja suficiente e a ordem permaneça inalterada até que o preço de venda de stop loss ou o preço de venda do take profit seja atingido e nenhum encargo adicional seja incorrido, qual seria o lucro ou perda que você incorreria em sua conta quando a posição for fechada?',
  ca_q18: '1. Qual é o seu rendimento anual total?',
  ca_q19: '2. Qual é a fonte de sua renda?',
  ca_q20: '3. Que percentagem do seu rendimento anual se relaciona com obrigações financeiras?',
  ca_q21: '4. Qual é o valor estimado dos seus Ativos?',
  ca_q22: '5. Qual é a estrutura do seu Patrimônio?',
  ca_q23: '6. Qual é o seu Patrimônio Líquido estimado (Total do Ativo – Total do Passivo)?',
  ca_q24: '1. Por favor, selecione uma das declarações abaixo:',
  ca_q25: '2. Qual das seguintes afirmações é mais apropriada para você?',
  ca_q26: '3. Qual é o mais relevante para o seu estilo de investimento?',
  ca_q27: '4. Com base em suas expectativas, qual é a flutuação anual do valor da sua carteira que você está disposto a aceitar?',
  ca_q28: '5. Qual das seguintes opções será considerada como a carteira mais adequada para si?',
  ca_q29: '6. Qual é o horizonte temporal dos seus objetivos de investimento?',
  ca_q30: '7. Qual é o seu objetivo de investimento?',
  ca_q31: '8. Qual é o nível de liquidez da sua carteira que você está disposto a aceitar?',
  ca_q1_ao1: 'a) Sim, eu investi em uma conta real',
  ca_q1_ao2: 'b) Sim, eu investai em uma conta demo',
  ca_q1_ao3: 'c) Não, mas recorri aos serviços de investimento da Portfolio Management e/ou Investment Advice',
  ca_q1_ao4: 'd) Não, mas tenho um vasto conhecimento através da minha formação (licenciatura, mestrado etc.)',
  ca_q1_ao5: 'e) Não',
  ca_q2_ao6: 'a) 0 - 6 meses',
  ca_q2_ao7: 'b) 6 - 12 meses',
  ca_q2_ao8: 'c) 1 - 2 anos',
  ca_q2_ao9: 'd) 2 - 4 anos',
  ca_q2_ao10: 'e) Acima de 4 anos',
  ca_q3_ao11: 'I. Nunca',
  ca_q3_ao12: 'II. Raramente (menos de 50 vezes)',
  ca_q3_ao13: 'III. Às vezes (50-100 vezes)',
  ca_q3_ao14: 'IV. Frequentemente (mais de 101 investimentos)',
  ca_q4_ao15: 'I. Nunca',
  ca_q4_ao16: 'II. Raramente (menos de 50 vezes)',
  ca_q4_ao17: 'III. Às vezes (50-100 vezes)',
  ca_q4_ao18: 'IV. Frequentemente (mais de 101 investimentos)',
  ca_q5_ao19: 'I. Nunca',
  ca_q5_ao20: 'II. Raramente (menos de 50 vezes)',
  ca_q5_ao21: 'III. Às vezes (50-100 vezes)',
  ca_q5_ao22: 'IV. Frequentemente (mais de 101 investimentos)',
  ca_q6_ao23: 'I. Nunca',
  ca_q6_ao24: 'II. Raramente (menos de 50 vezes)',
  ca_q6_ao25: 'III. Às vezes (50-100 vezes)',
  ca_q6_ao26: 'IV. Frequentemente (mais de 101 investimentos)',
  ca_q7_ao27: 'i. 0',
  ca_q7_ao28: 'Ii. Menos de €500',
  ca_q7_ao29: 'iii. €501 - €2.000',
  ca_q7_ao30: 'iv. €2.001 - €5.000',
  ca_q7_ao31: 'v. Mais de €5.001',
  ca_q8_ao32: 'i. 0',
  ca_q8_ao33: 'Ii. Menos de €500',
  ca_q8_ao34: 'iii. €501 - €2.000',
  ca_q8_ao35: 'iv. €2.001 - €5.000',
  ca_q8_ao36: 'v. Mais de €5.001',
  ca_q9_ao37: 'i. 0',
  ca_q9_ao38: 'Ii. Menos de €500',
  ca_q9_ao39: 'iii. €501 - €2.000',
  ca_q9_ao40: 'iv. €2.001 - €5.000',
  ca_q9_ao41: 'v. Mais de €5.001',
  ca_q10_ao42: 'i. 0',
  ca_q10_ao43: 'Ii. Menos de €500',
  ca_q10_ao44: 'iii. €501 - €2.000',
  ca_q10_ao45: 'iv. €2.001 - €5.000',
  ca_q10_ao46: 'v. Mais de €5.001',
  ca_q11_ao47: 'a. Recepção e transmissão e/ou execução de ordens (serviços de investimentos que requerem decisões independentes)',
  ca_q11_ao48: 'b. Consultoria de investimento',
  ca_q11_ao49: 'c. Gerenciamento de Portfólio',
  ca_q11_ao50: 'd. Nenhum',
  ca_q12_ao51: 'a. Tenho experiência profissional relevante',
  ca_q12_ao52: 'b. Monitoro regularmente as notícias/mercados',
  ca_q12_ao53: 'c. Participei de um seminário ou curso relacionado a Mercados Financeiros / Investimentos / investimento Online',
  ca_q12_ao54: 'd. Nenhum dos itens acima',
  ca_q13_ao55: 'a. -€1.200',
  ca_q13_ao56: 'b. -€1.400',
  ca_q13_ao57: 'c. -€1.600',
  ca_q13_ao58: 'd. -€1.800',
  ca_q14_ao59: 'a. -€6.000',
  ca_q14_ao60: 'b. -€7.000',
  ca_q14_ao61: 'c. -€8.000',
  ca_q14_ao62: 'd. -€10.000',
  ca_q15_ao63: 'a. Protege você de sofrer perdas rápidas',
  ca_q15_ao64: 'b. Limita a sua exposição ao risco',
  ca_q15_ao65: 'c. Garante que você nunca tenha uma perda em um investimento',
  ca_q15_ao66: 'd. Protege você do risco de usar alavancagem',
  ca_q16_ao67: 'a. Se o preço do subjacente em uma posição aberta se mover contra você para que seu patrimônio se mova abaixo de sua margem mínima de manutenção.',
  ca_q16_ao68: 'b. Se você incorrer em taxas de transação que colocam sua conta em déficit.',
  ca_q16_ao69: 'c. Se uma posição de CFD aberta incorrer em cobranças durante a noite, isso coloca sua conta em déficit.',
  ca_q16_ao70: 'd. Todos os itens acima.',
  ca_q17_ao71: 'a. -$100 ou $300',
  ca_q17_ao72: 'b. -$200 ou $600',
  ca_q17_ao73: 'c. -$2.000 ou $6.000',
  ca_q17_ao74: 'd. -$4.000 ou $12.000',
  ca_q18_ao75: 'a. Menos de €20.000',
  ca_q18_ao76: 'b. Entre €20.000 e €50.000',
  ca_q18_ao77: 'c. Entre € 50.000 e € 100.000',
  ca_q18_ao78: 'd. Mais de €100.000',
  ca_q19_ao79: 'a. Salário/ Pensão',
  ca_q19_ao80: 'b. Dividendos/ Juros/ Cupons',
  ca_q19_ao81: 'c. Aluga',
  ca_q19_ao82: 'd. Doações/ Herança',
  ca_q19_ao83: 'e. Outra fonte de renda',
  ca_q20_ao84: 'a. Menos de 25%',
  ca_q20_ao85: 'b. Entre 25% e 50%',
  ca_q20_ao86: 'c. Entre 50% e 75%',
  ca_q20_ao87: 'd. Mais de 75%',
  ca_q21_ao88: 'a. Menos de €100.000',
  ca_q21_ao89: 'b. Entre €100.000 e €500.000',
  ca_q21_ao90: 'c. Entre € 500.000 e € 1.000.000',
  ca_q21_ao91: 'd. Mais de €1.000.000',
  ca_q22_ao92: 'a. Principalmente em depósitos bancários',
  ca_q22_ao93: 'b. Principalmente no setor imobiliário',
  ca_q22_ao94: 'c. Principalmente em Instrumentos Financeiros',
  ca_q22_ao95: 'd. Alocado igualmente em todas as três opções acima',
  ca_q22_ao96: 'e. Outro',
  ca_q23_ao97: 'a. Menos de €100.000',
  ca_q23_ao98: 'b. Entre €100.000 e €500.000',
  ca_q23_ao99: 'c. Entre € 500.000 e € 1.000.000',
  ca_q23_ao100: 'd. Mais de €1.000.000',
  ca_q24_ao101: 'a. Eu só assumo riscos que podem diminuir meu capital investido em circunstâncias extremas.',
  ca_q24_ao102: 'b. Posso arriscar uma parte do meu capital investido para alcançar um retorno acima da média.',
  ca_q24_ao103: 'c. Posso arriscar uma parte ou a totalidade do meu capital investido, na esperança de obter retornos mais elevados.',
  ca_q25_ao104: 'a. O mais importante para mim é a segurança do meu capital. Assim, a fim de evitar qualquer perda, estou pronto para desistir de retornos mais altos.',
  ca_q25_ao105: 'b. A fim de obter retornos mais altos do que a média, aceito assumir riscos mais altos e estou pronto para aceitar a ligeira diminuição do meu capital.',
  ca_q25_ao106: 'c. Para altos retornos, estou pronto para assumir altos riscos, mesmo que uma parte ou a totalidade do meu capital esteja em risco.',
  ca_q26_ao107: 'a. Preservação do capital',
  ca_q26_ao108: 'b. Crescimento da renda',
  ca_q26_ao109: 'c. Especulação',
  ca_q26_ao110: 'd. Cobertura',
  ca_q27_ao111: 'a. ± 5%',
  ca_q27_ao112: 'b. ± 10%',
  ca_q27_ao113: 'c. ± 25%',
  ca_q27_ao114: 'd. ± 50%',
  ca_q28_ao115: 'a. Aquele que produzirá um retorno estável de 1 a 2% nos próximos anos.',
  ca_q28_ao116: 'b. Aquele que produzirá retornos entre -2% e +10% nos próximos anos.',
  ca_q28_ao117: 'c. Aquele que se espera que produza retornos entre -15% e +30% no próximo ano e pode até levar a uma perda superior ao valor investido em condições extremas.',
  ca_q29_ao118: 'a. Até 1 ano',
  ca_q29_ao119: 'b. Entre 1 e 3 anos',
  ca_q29_ao120: 'c. Entre 3 e 5 anos',
  ca_q29_ao121: 'd. Mais de 5 anos',
  ca_q30_ao122: 'a. Gestão de liquidez de curto prazo, a fim de cobrir despesas inesperadas.',
  ca_q30_ao123: 'b. Poupança a longo prazo.',
  ca_q30_ao124: 'c. Faça altos lucros mesmo correndo o risco de perder o valor investido',
  ca_q31_ao125: 'a. Menos de 25%',
  ca_q31_ao126: 'b. Entre 25% e 50%',
  ca_q31_ao127: 'c. Entre 50% e 75%',
  ca_q31_ao128: 'd. Mais de 75%',
  passport_ple_different: 'Caso o seu país de residência e o país de emissão do seu documento de identificação sejam diferentes, carregue o seu passaporte.',
  live_account: 'Conta Real',
  agree_terms_marketing: 'Concordo em receber atualizações de marketing da Eurotrader (ver <a href="{PRIVACY_URL}" target="_blank">Política de Privacidade</a>).',
  data_policy_text:
    'Seus dados estão seguros conosco e você pode cancelar a inscrição a qualquer momento. Ao clicar abaixo, você está confirmando que leu e aceitou os <a href="{TERMS_CONDITIONS_URL}" target="_blank">T&amp;Cs</a> e a <a href="{RISK_DISCLOSURE_URL}" target="_blank"> divulgação de riscos</a> e concorda que armazenemos e processemos suas informações pessoais.',
  live_tos_with_link: 'Li, compreendi e aceitei os termos e condições e a divulgação de avisos de risco <a href="{URL}" target="_blank">aqui</a>.',
  must_agree_marketing_terms: 'Marque a caixa de seleção para prosseguir para a próxima etapa',
  tick_checkboxes: 'Marque as caixas de seleção para prosseguir',
  partner_account: 'Conta de parceiro',
  privacy_policy: 'política de privacidade',
  client: 'cliente',
  commission_amount: 'valor da comissão',
  tier_name: 'nome da camada',
  trades_completed: 'investimentos concluídas',
  trade: 'comércio',
  pamm_investor_selection_note:
    '* Por favor, note que as "contas de investidor" são especificamente projetadas para serem usadas em conexão com uma conta mestra e não podem ser negociadas manualmente. Entre em contato com o suporte ao cliente se quiser saber mais sobre contas de investidores',
  bitpace_network_warning_BTC: 'Este endereço é apenas para depósitos em Bitcoin. Não envie de uma rede que não seja BTC ou o seu depósito pode ser perdido',
  bitpace_network_warning_LTC: 'Este endereço é apenas para depósitos Litecoin. Não envie de uma rede que não seja LTC ou o seu depósito pode ser perdido',
  bitpace_network_warning_XRP: 'Este endereço é apenas para depósitos Ripple. Não envie de uma rede que não seja XRP ou o seu depósito pode ser perdido',
  bitpace_network_warning_BCH: 'Este endereço é apenas para depósitos em Bitcoin Cash. Não envie de uma rede que não seja BCH ou o seu depósito pode ser perdido',
  bitpace_network_warning_USDT:
    'Use apenas as redes Ethereum (ERC20) ou TRON (TRC20). Seu depósito será perdido e irrecuperável se você não usar as redes especificadas. Por favor, não envie fundos via BSC, BEP20, BEP-2 ou outras redes.',
  bitpace_network_warning_USDC:
    'Use apenas as redes Ethereum (ERC20) ou TRON (TRC20). Seu depósito será perdido e irrecuperável se você não usar as redes especificadas. Por favor, não envie fundos via BSC, BEP20, BEP-2 ou outras redes.',
  bitpace_network_warning_TRX:
    'Use apenas a rede TRON (TRC20). Seu depósito será perdido e irrecuperável se você não usar a rede TRON. Por favor, não envie fundos via BSC, BEP20, BEP-2 ou outras redes.',
  bitpace_network_warning_LINK:
    'Por favor, use apenas a rede Ethereum (ERC20). Seu depósito será perdido e irrecuperável se você não usar a rede Ethereum. Por favor, não envie fundos via BSC, BEP20, BEP-2, TRC ou outras redes.',
  crypto_note_text:
    "Caro cliente, <br><br>Estamos muito satisfeitos em compartilhar que nosso depósito e retirada de criptomoeda foram atualizados com uma seleção de moedas para escolher, incluindo Ethereum, Ripple, Litecoin e muito mais. Muito obrigado pela sua paciência, e pedimos desculpas por qualquer inconveniente causado. <br><br><strong>Por favor, note: você precisa clicar em 'Criar endereço' e copiar o endereço mais recente toda vez que quiser depositar.</strong>",
  crypto_visit_page: 'Sempre visite esta página para obter o endereço de criptomoeda mais recente antes de depositar.',
  pamm_statistics_text:
    'As estatísticas da Pamm estão disponíveis na nossa área de clientes PAMM. Se você tiver uma conta PAMM, clique no link abaixo para ser redirecionado e use suas credenciais de conta PAMM para fazer login.',
  leverage: 'Alavancagem',
  bitpace_network_warning_BTC_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja em BTC. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_LTC_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja em LTC. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_XRP_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja em XRP. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_BCH_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja em BCH. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_USDT_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja nas redes ERC20 ou TRC20 e esteja em USDT. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_USDC_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja nas redes ERC20 ou TRC20 e esteja em USDC. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_TRX_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja na rede TRC20 e esteja no TRX. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
  bitpace_network_warning_LINK_withdrawal:
    'Certifique-se de que o endereço da carteira inserido esteja correto e esteja nas redes ERC20 ou TRC20 e esteja no LINK. Inserir o endereço errado fará com que seus fundos sejam perdidos.',
}



// WEBPACK FOOTER //
// ./src/locale/pt.js